import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RangeSlider from 'shared/components/RangeSlider';
import { DEFAULT_CURRENCY } from 'shared/constants';
import { createMoneyFormatter } from 'shared/lib/formatters';
import AggregationBox from './AggregationBox';
import styles from './AggregationBox.module.scss';

const RateRangeBox = ({ current, type, title, defaultValue, min, max, step, onSelect, onReset, currency }) => {
  const [value, setValue] = useState(defaultValue);
  const { i18n, t } = useTranslation('common');

  useEffect(() => {
    const externalValue = current ? ~~current.slug : 0;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [current]);

  const formatMoney = createMoneyFormatter(i18n.language);
  const formatValue = (v) => {
    if (type === 'rate' && v > 0) {
      return formatMoney(v, currency);
    }

    return v;
  };

  const onChange = values => setValue(values[0]);

  const onFinalChange = (values) => {
    if (values[0] > 0) {
      onSelect(values[0]);
    } else {
      onReset();
    }
  };

  return (
    <AggregationBox title={title}>
      <div className={styles.rangeContent} id={`${type}-box`}>
        <RangeSlider
          min={min}
          max={max}
          step={step}
          values={[value]}
          labels={[value > 0 ? formatValue(value) : t('slider.notSelected'), formatValue(max)]}
          onChange={onChange}
          onFinalChange={onFinalChange}
        />
      </div>
    </AggregationBox>
  );
};

RateRangeBox.propTypes = {
  current: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.string,
  defaultValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onSelect: PropTypes.func,
  onReset: PropTypes.func,
  currency: PropTypes.string
};

RateRangeBox.defaultProps = {
  current: null,
  title: '',
  type: null,
  defaultValue: 0,
  min: 0,
  max: 0,
  step: 1,
  onSelect() {},
  onReset() {},
  currency: DEFAULT_CURRENCY
};

export default RateRangeBox;
